//
//
//
//
//
//
//
//
//
//

/* Version: 1.3 */
import { mapState } from "vuex";
import AQTreeConfigItem from "./AQTreeConfigItem.vue";

export default {
    name: "AQTreeConfigBody",
    components: {
        AQTreeConfigItem
    },
    props: {
        dataItem: { type: Object, default: () => {} },
        dataForLoad: { type: Object, default: () => {} },
        hideDMPicker: { type: Boolean, default: false }
    },
    data() {
        return {
            embeddedFields: [],
            parentsPath: {},
            dataItemProcessed: [],
            currentSection: null,
            emittedHide: {},
            sectionWrappers: ["$header", "$path", "$query", "$body"],
            sectionFullPaths: [],
            migrationMappingsAddItem: {},
            migrationMappingsRemoveArray: [],
            generalTypes: ["boolean", "string", "integer", "decimal", "date", "time", "datetime", "attachment", "richtext"],
            displayTypes: ["bool", "str", "int", "dec", "date", "time", "dtm", "att", "rtxt"]
        };
    },
    computed: {
        ...mapState("diagrams", ["isFromResponse"])
    },
    watch: {
        dataItem: {
            handler(newValue) {
                this.dataItemProcessed = this.getSectionData(newValue);
                this.embeddedFields = [];
            },
            immediate: true
        }
    },
    created() {
        this.$root.$on("sendRequestResponseHide", data => {
            if (data && data.routeName === this.$route.name) {
                this.emittedHide = { ...this.emittedHide, ...data.newDataHide };
            }
        });
    },
    methods: {
        listType(field, definitions, defObj) {
            let listedType = {};

            if (field.isPrimitive && !field.isReference) { // primitives
                listedType = {
                    type: field.defType[0],
                    display: [this.getDisplayTypes(field.defType[0])]
                };
            } else if (!field.isComplex && !field.isList && defObj && definitions[defObj] && definitions[defObj].isPrimitive) { // primitives by reference
                listedType = {
                    type: definitions[defObj].defType[0],
                    display: [this.getDisplayTypes(definitions[defObj].defType[0])]
                };
            }

            if ((field.isList && field.items && field.items.isComplex) || (field.isReference && defObj && definitions[defObj]
                && definitions[defObj].isList && definitions[defObj].items.isComplex)) { // list of objects
                listedType = {
                    type: "list",
                    display: ["obj", "list"],
                    objDef: defObj,
                    isList: true
                };
            }
            if (field.isComplex && !field.isList && defObj && definitions[defObj] && definitions[defObj].isComplex) { // objects
                listedType = {
                    type: "object",
                    display: ["obj"],
                    objDef: defObj
                };
            }
            if (field.isReference && !field.isPrimitive && field.isList) {
                if (field.items && field.items.isPrimitive) { // list of primitives
                    [listedType.type] = field.items.defType;
                    listedType.display = [this.getDisplayTypes(field.items.defType[0]), "list"];
                    listedType.isSimpleList = true;
                    listedType.isList = false;
                }
                if (defObj && definitions[defObj] && definitions[defObj].isList && !definitions[defObj].items.isList && !definitions[defObj].items.isComplex) {
                    // list of objects with primitives
                    if (!definitions[defObj].items.isPrimitive && definitions[defObj].items.isReference) {
                        // list item object = list of objects of primitive type
                        const primitivesObj = definitions[defObj].items.defType[0];
                        [listedType.type] = definitions[primitivesObj].defType;
                        listedType.display = [this.getDisplayTypes(definitions[primitivesObj].defType[0]), "list"];
                    } else {
                        // list item object = list of primitive type
                        [listedType.type] = definitions[defObj].items.defType;
                        listedType.display = [this.getDisplayTypes(definitions[defObj].items.defType[0]), "list"];
                    }
                    listedType.isSimpleList = true;
                    listedType.isList = false;
                }
            }
            return listedType;
        },
        buildDisplayElem(definitions, complexElem) {
            const result = [];
            const elements = complexElem.fields || complexElem.items;
            if (complexElem && elements) {
                if (elements && elements.length) {
                    elements.forEach((field) => {
                        let el = null;
                        if (field.isPrimitive && !field.isReference) {
                            const currentType = this.listType(field, definitions);
                            const fullPathVars = (this.parentsPath.vars ? `${this.parentsPath.vars}.` : "") + field.name;

                            el = {
                                label: field.name,
                                type: currentType.type,
                                typeListed: currentType.display,
                                isList: currentType.isList || false,
                                isSimpleList: currentType.isSimpleList || false,
                                header: "generic",
                                mandatory: field.required || false,
                                in: this.currentSection,
                                hide: field.isHidden || false,
                                value: this.getDMLoadValue(fullPathVars, field.name, field.alias),
                                fullPath: fullPathVars
                            };
                        } else if (definitions) {
                            if (definitions[field.defType[0]]
                                || (field.isList && !field.isReference && field.items && !field.items.isPrimitive && definitions[field.items.defType[0]])) {
                                // eslint-disable-next-line no-nested-ternary
                                const defObj = definitions ? (field.items ? Object.keys(definitions).filter(definition => definition === field.items.defType[0])
                                    : Object.keys(definitions).filter(definition => definition === field.defType[0])) : null; // definition for current object
                                const currentType = this.listType(field, definitions, defObj);
                                if (!this.objAlreadyExists(currentType.objDef, this.parentsPath.types)
                                    && defObj && definitions[defObj]) { // if (not cyclic object reference) && (definition exists)
                                    el = {
                                        label: field.name,
                                        type: currentType.type,
                                        typeListed: currentType.display,
                                        isList: currentType.isList || false,
                                        isSimpleList: currentType.isSimpleList || false,
                                        header: "generic",
                                        mandatory: definitions[defObj].required || false,
                                        in: this.currentSection,
                                        hide: field.isHidden || false,
                                        children: []
                                    };

                                    if (definitions[defObj].isComplex || definitions[defObj].isList || definitions[defObj].isPrimitive) {
                                        const currentDef = ((definitions[defObj].isComplex && !definitions[defObj].isList) || definitions[defObj].isPrimitive)
                                            ? definitions[defObj] : definitions[definitions[defObj].items.defType[0]];
                                        if (currentDef) {
                                            this.parentsPath.vars = (this.parentsPath.vars ? `${this.parentsPath.vars}.` : "") + field.name;
                                            this.parentsPath.types = (this.parentsPath.types ? `${this.parentsPath.types}.` : "")
                                                + (currentType.objDef ? currentType.objDef : "");
                                            const pathBEformat = this.parentsPath.vars + ((currentType.isList && currentType.objDef) ? "._path_" : "");
                                            el.value = this.getDMLoadValue(pathBEformat, field.name, field.alias);
                                            el.fullPath = pathBEformat;
                                            el.children = el.children.concat(this.buildDisplayElem(definitions, currentDef));
                                            if (el.children && el.children.length && !this.sectionWrappers.includes(el.label)) {
                                                el.children.forEach((item) => {
                                                    item.hide = typeof this.emittedHide[el.fullPath] !== "undefined" ? this.emittedHide[el.fullPath] : true;
                                                });
                                            }
                                        } else { // list of primitives from $body:
                                            this.parentsPath.vars = (this.parentsPath.vars ? `${this.parentsPath.vars}.` : "") + field.name;
                                            el.value = this.getDMLoadValue(this.parentsPath.vars, field.name, field.alias);
                                            el.fullPath = this.parentsPath.vars;
                                            if (definitions[defObj].items.isPrimitive && field.location) {
                                                this.parentsPath.vars = "";
                                            }
                                        }
                                        const prevparentsPathVars = el.isSimpleList && this.parentsPath.vars ? this.parentsPath.vars : "";
                                        // eslint-disable-next-line no-nested-ternary
                                        this.parentsPath.vars = this.parentsPath.vars && this.parentsPath.vars.lastIndexOf(".") >= 0
                                            ? this.parentsPath.vars.slice(0, this.parentsPath.vars.lastIndexOf(".")) : prevparentsPathVars;
                                        const prevParentsPathTypes = el.isSimpleList && this.parentsPath.vars ? this.parentsPath.types : "";
                                        // eslint-disable-next-line no-nested-ternary
                                        this.parentsPath.types = this.parentsPath.types && this.parentsPath.types.lastIndexOf(".") >= 0
                                            ? this.parentsPath.types.slice(0, this.parentsPath.types.lastIndexOf(".")) : prevParentsPathTypes;
                                    }
                                }
                            }
                        }
                        if (el) {
                            result.push(el);
                        }
                    });
                }
            }
            return result;
        },
        objAlreadyExists(item, dottedString) {
            item = item && item[0] ? item[0] : item;
            return (item && dottedString && dottedString.length) ? (dottedString.split(".").indexOf(item) >= 0) : false;
        },
        getDisplayTypes(cType) {
            const toDisplay = cType.toLowerCase();
            return this.generalTypes.includes(toDisplay) ? this.displayTypes[this.generalTypes.indexOf(toDisplay)] : toDisplay;
        },
        getDMLoadValue(path, fieldName, fieldAlias) { // fieldAlias comes from $body mappings migration only
            if (!this.sectionFullPaths.includes(path)) {
                this.sectionFullPaths.push(path);
            }
            let mapVal = "";
            if (path && this.dataForLoad) {
                mapVal = this.dataForLoad[path] || "";
                if (fieldAlias && fieldName
                    && (this.dataForLoad[fieldAlias] && this.dataForLoad[`${fieldName}.${fieldAlias}`])
                    && (this.dataForLoad[fieldAlias] === this.dataForLoad[`${fieldName}.${fieldAlias}`])) { // $body alias mappings migration conversion
                    mapVal = this.dataForLoad[fieldAlias];
                    this.migrationMappingsAddItem[`${fieldName}`] = mapVal;
                    this.migrationMappingsRemoveArray = [fieldAlias, `${fieldName}.${fieldAlias}`];
                }
            }
            return mapVal;
        },
        getSectionData(data) {
            if (data && data.schema) {
                this.currentSection = data.schema[0].location;
                this.parentsPath = {};
                const currentFields = {};
                currentFields.fields = data.schema;
                this.embeddedFields = this.buildDisplayElem(data.definitions, currentFields);
                if (this.dataForLoad && this.dataForLoad.__migrated && this.dataForLoad.__migrated === true) { // send migration conversion data
                    this.$root.$emit("updateMappingsMigration", {
                        routeName: this.$route.name,
                        isRequest: !this.isFromResponse,
                        sectionFullPaths: this.sectionFullPaths,
                        removeArray: this.migrationMappingsRemoveArray,
                        addItem: this.migrationMappingsAddItem
                    });
                }
            }
            return this.embeddedFields;
        }
    }
};
